var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 2.94971V11.283C18.3332 11.8356 18.1137 12.3655 17.723 12.7562C17.3323 13.1469 16.8024 13.3664 16.2498 13.3664H3.74984C3.1973 13.3664 2.6674 13.1469 2.2767 12.7562C1.886 12.3655 1.6665 11.8356 1.6665 11.283V2.94971",
    stroke: "#170F49",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 2.94954C18.3332 2.39701 18.1137 1.86711 17.723 1.47641C17.3323 1.0857 16.8024 0.866211 16.2498 0.866211H3.74984C3.1973 0.866211 2.6674 1.0857 2.2767 1.47641C1.886 1.86711 1.6665 2.39701 1.6665 2.94954L8.89567 7.46343C9.22678 7.67038 9.60938 7.78011 9.99984 7.78011C10.3903 7.78011 10.7729 7.67038 11.104 7.46343L18.3332 2.94954Z",
    stroke: "#170F49",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.4612b40514edcbdfb77bbc48c766c653.svg";
export { ForwardRef as ReactComponent };